(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gallery"] && !Shopify.designMode) return;
  try {
    
 $('.gallery-pop').magnificPopup({
      type: 'image',
      closeOnContentClick: true,
      mainClass: 'mfp-img-mobile',
      image: {
        verticalFit: true
      }

    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pc-storefront"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initialize(root) {
    if (root.dataset.pcReady) return;
    root.dataset.pcReady = 'true';
    const slides = Array.from(root.querySelectorAll('[data-pc-slide]'));
    const counter = root.querySelector('[data-pc-counter]');
    let index = 0;
    const show = (offset) => {
      slides[index].hidden = true;
      index = (index + offset + slides.length) % slides.length;
      slides[index].hidden = false;
      if (counter) counter.textContent = (index + 1) + ' / ' + slides.length;
    };
    root.querySelector('[data-pc-prev]')?.addEventListener('click', () => show(-1));
    root.querySelector('[data-pc-next]')?.addEventListener('click', () => show(1));
  }
  document.querySelectorAll('.pc-store').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('.pc-store').forEach(initialize));
})();

  } catch(e) { console.error(e); }
})();
})();
